import { nextPayPeriod, periodLabel, previousPayPeriod } from '@kronos/domain'
import type { LocalDate, PayPeriod } from '@kronos/domain'

/** ‹ 16 – 31 Oct 2026 ›. Forward stops at the period that contains today. */
export function PeriodNav({
  period,
  today,
  onChange,
}: {
  period: PayPeriod
  today: LocalDate
  onChange: (date: LocalDate) => void
}): JSX.Element {
  const next = nextPayPeriod(period)
  return (
    <div className="period-nav">
      <button aria-label="Previous pay period" onClick={() => onChange(previousPayPeriod(period).from)}>
        ‹
      </button>
      <span className="period-nav__label">{periodLabel(period)}</span>
      <button aria-label="Next pay period" disabled={next.from > today} onClick={() => onChange(next.from)}>
        ›
      </button>
    </div>
  )
}
